import { render, staticRenderFns } from "./delayed-details.vue?vue&type=template&id=2c03e2ba&"
import script from "./delayed-details.vue?vue&type=script&lang=js&"
export * from "./delayed-details.vue?vue&type=script&lang=js&"
import style0 from "./delayed-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports